export default {
  title: 'Anti-Fake Management',
  qrCodeList: 'QR Code List',
  scanRecords: 'Scan Records',
};
